import $ from 'jquery';

$('.faq__item').each(function(){
    $(this).on('click', function(){
        
        
        if (!$(this).hasClass('active')){
            $('.faq__item').removeClass('active');
            $('.faq__item .faq__answ').slideUp();

            $(this).find('.faq__answ').slideDown();
            $(this).addClass('active');
        }else{
            $(this).find('.faq__answ').slideUp();
            $(this).removeClass('active');
        }
    });
});